import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dots",
  "use": "dots-usage",
  "viewBox": "0 0 10 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 24\" id=\"dots\"><path d=\"M1.5 3a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM10 8.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM1.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm8.5 5.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM1.5 17a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm8.5 5.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM1.5 24a1.5 1.5 0 100-3 1.5 1.5 0 000 3z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol